import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/rightArrowFilled.svg'
import _imports_1 from '@/assets/downArrow.svg'
import _imports_2 from '@/assets/videoAdd.svg'
import _imports_3 from '@/assets/editImage.svg'
import _imports_4 from '@/assets/addImage.svg'
import _imports_5 from '@/assets/audio.svg'
import _imports_6 from '@/assets/correctIcon.svg'
import _imports_7 from '@/assets/cancel.svg'
import _imports_8 from '@/assets/deleteIcon.svg'
import _imports_9 from '@/assets/editIcon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4be92f0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-3 px-5" }
const _hoisted_2 = {
  key: 0,
  class: "w-full pt-2"
}
const _hoisted_3 = { class: "header flex items-center justify-between" }
const _hoisted_4 = { class: "flex cursor-pointer" }
const _hoisted_5 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "w-full flex items-center" }
const _hoisted_9 = { class: "mx-2.5" }
const _hoisted_10 = {
  key: 0,
  src: _imports_0,
  class: "h-4 w-4 cursor-pointer"
}
const _hoisted_11 = {
  key: 1,
  src: _imports_1,
  class: "h-4 w-4 cursor-pointer"
}
const _hoisted_12 = { class: "title flex font-opensans text-sm ml-1" }
const _hoisted_13 = { class: "screenName" }
const _hoisted_14 = { class: "mr-1" }
const _hoisted_15 = {
  key: 0,
  class: "rounded-full w-5 h-5 bg-green mx-auto"
}
const _hoisted_16 = {
  key: 1,
  class: "rounded-full w-5 h-5 bg-error mx-auto"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-t-2" }, null, -1))
const _hoisted_19 = { class: "pt-3 px-5" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "w-full" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-xs mb-2" }, "Screen Name", -1))
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_28 = { class: "flex justify-end items-end pl-6" }
const _hoisted_29 = { class: "switch" }
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_32 = { class: "mt-3" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-2" }, "Select Screen", -1))
const _hoisted_34 = ["onUpdate:modelValue", "disabled", "onChange"]
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<option value=\"\" selected disabled hidden data-v-4be92f0e>Please select screen</option><option value=\"RadioScreen\" data-v-4be92f0e>Radio Screen</option><option value=\"TextBoxScreen\" data-v-4be92f0e>TextBox Screen</option><option value=\"CheckBoxScreen\" data-v-4be92f0e>CheckBox Screen</option><option value=\"TabScreen\" data-v-4be92f0e>Tab Screen</option><option value=\"VerticallyAccordionScreen\" data-v-4be92f0e>VerticallyAccordion Screen</option><option value=\"HorizantallyAccordionScreen\" data-v-4be92f0e>HorizantallyAccordion Screen</option><option value=\"TextWithBulletPointsScreen\" data-v-4be92f0e>TextWith BulletPoints Screen</option><option value=\"VideoScreen\" data-v-4be92f0e>Video Screen</option>", 9)
const _hoisted_44 = [
  _hoisted_35
]
const _hoisted_45 = { key: 0 }
const _hoisted_46 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "formgroup mt-2.5" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Video", -1))
const _hoisted_50 = ["htmlFor"]
const _hoisted_51 = ["id", "onChange"]
const _hoisted_52 = { class: "flex inputboxstylingforAddVideo justify-center items-center cursor-pointer border rounded py-2 border-lightgrey" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "flex justify-center" }
const _hoisted_55 = ["htmlFor"]
const _hoisted_56 = { class: "flex justify-center items-center mt-2" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { class: "text-sm font-bold" }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = ["htmlFor"]
const _hoisted_61 = { class: "flex justify-center items-center mt-2" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "text-sm font-bold" }
const _hoisted_64 = { key: 2 }
const _hoisted_65 = { class: "flex justify-center" }
const _hoisted_66 = ["htmlFor"]
const _hoisted_67 = ["src"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "-mt-10 flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "borderstyle p-1" }, "Edit Video")
], -1))
const _hoisted_69 = { class: "flex justify-center items-center mt-2" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { class: "text-sm font-bold" }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { class: "formgroup mt-3" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-xs mb-2" }, "Enter the Header", -1))
const _hoisted_75 = ["onUpdate:modelValue"]
const _hoisted_76 = { key: 0 }
const _hoisted_77 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_78 = { class: "formgroup mt-3" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-2" }, "Enter the Header Text", -1))
const _hoisted_80 = ["onUpdate:modelValue"]
const _hoisted_81 = { key: 0 }
const _hoisted_82 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_83 = {
  key: 1,
  class: "text-red-500 text-xs"
}
const _hoisted_84 = {
  key: 0,
  class: "formgroup mt-3"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-2" }, "Image", -1))
const _hoisted_86 = ["htmlFor"]
const _hoisted_87 = ["id", "onChange"]
const _hoisted_88 = { class: "flex inputboxstylingforAddImage justify-center items-center cursor-pointer border rounded py-2 border-lightgrey" }
const _hoisted_89 = { key: 0 }
const _hoisted_90 = ["htmlFor"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "w-52 h-32 cursor-pointer"
}, null, -1))
const _hoisted_92 = [
  _hoisted_91
]
const _hoisted_93 = { class: "flex justify-center items-center mt-2" }
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { class: "text-sm font-bold" }
const _hoisted_96 = { key: 1 }
const _hoisted_97 = ["htmlFor"]
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "w-52 h-32 cursor-pointer"
}, null, -1))
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = { class: "flex justify-center items-center mt-2" }
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { class: "text-sm font-bold" }
const _hoisted_103 = {
  key: 2,
  class: "mt-px"
}
const _hoisted_104 = { class: "flex justify-center" }
const _hoisted_105 = ["htmlFor"]
const _hoisted_106 = ["src"]
const _hoisted_107 = ["htmlFor"]
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "-mt-10 flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "borderstyle p-1 font-semibold text-xs cursor-pointer" }, "Edit Image")
], -1))
const _hoisted_109 = [
  _hoisted_108
]
const _hoisted_110 = { class: "flex justify-center items-center mt-2" }
const _hoisted_111 = { key: 0 }
const _hoisted_112 = { class: "text-sm font-bold" }
const _hoisted_113 = {
  key: 1,
  class: "formgroup mt-3"
}
const _hoisted_114 = { class: "formgroup mt-3" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-2" }, "Audio", -1))
const _hoisted_116 = ["htmlFor"]
const _hoisted_117 = ["id", "onChange"]
const _hoisted_118 = { class: "flex inputboxstylingforAddAudio justify-center items-center cursor-pointer border rounded py-2 border-lightgrey" }
const _hoisted_119 = { key: 0 }
const _hoisted_120 = ["htmlFor"]
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  class: "w-52 h-32 cursor-pointer"
}, null, -1))
const _hoisted_122 = [
  _hoisted_121
]
const _hoisted_123 = { class: "flex justify-center items-center mt-2" }
const _hoisted_124 = { key: 0 }
const _hoisted_125 = { class: "text-sm font-bold" }
const _hoisted_126 = { key: 1 }
const _hoisted_127 = ["htmlFor"]
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "w-52 h-32 cursor-pointer"
}, null, -1))
const _hoisted_129 = [
  _hoisted_128
]
const _hoisted_130 = { class: "flex justify-center items-center mt-2" }
const _hoisted_131 = { key: 0 }
const _hoisted_132 = { class: "text-sm font-bold" }
const _hoisted_133 = {
  key: 2,
  class: "mt-px"
}
const _hoisted_134 = { class: "flex justify-center" }
const _hoisted_135 = ["htmlFor"]
const _hoisted_136 = ["htmlFor"]
const _hoisted_137 = ["src"]
const _hoisted_138 = { class: "-mt-14 flex justify-center" }
const _hoisted_139 = ["htmlFor"]
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "borderstyle p-1 text-sm font-semibold text-black" }, "Edit Audio", -1))
const _hoisted_141 = [
  _hoisted_140
]
const _hoisted_142 = { class: "flex justify-center items-center mt-6" }
const _hoisted_143 = { key: 0 }
const _hoisted_144 = { class: "text-sm font-bold" }
const _hoisted_145 = {
  key: 2,
  class: "formgroup mt-3"
}
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-2" }, "Enter the options Header", -1))
const _hoisted_147 = ["onUpdate:modelValue"]
const _hoisted_148 = { class: "optionsblock" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm" }, "Enter the option", -1))
const _hoisted_150 = { class: "imgoptioncontainer flex" }
const _hoisted_151 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "h-5 w-5"
}, null, -1))
const _hoisted_153 = [
  _hoisted_152
]
const _hoisted_154 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "h-5 w-5"
}, null, -1))
const _hoisted_156 = [
  _hoisted_155
]
const _hoisted_157 = { class: "ml-2" }
const _hoisted_158 = ["onClick"]
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "h-5 w-5"
}, null, -1))
const _hoisted_160 = [
  _hoisted_159
]
const _hoisted_161 = {
  key: 0,
  class: "text-red-500 mt-1"
}
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-text" }, "At least 2 options are required.", -1))
const _hoisted_163 = [
  _hoisted_162
]
const _hoisted_164 = { class: "text-black no-underline mt-6 min-h-30" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between font-normal controllabel bg-white text-xs" }, "options to add", -1))
const _hoisted_166 = { class: "accordion-body p-3" }
const _hoisted_167 = { key: 0 }
const _hoisted_168 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_169 = { key: 1 }
const _hoisted_170 = { class: "formgroup mt-2.5 flex items-center" }
const _hoisted_171 = { htmlFor: "check" }
const _hoisted_172 = ["onUpdate:modelValue", "onChange"]
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "validateoption ml-2.5" }, "Only correct answer", -1))
const _hoisted_174 = { key: 2 }
const _hoisted_175 = { class: "formgroup mt-2.5 flex items-center" }
const _hoisted_176 = { htmlFor: "check" }
const _hoisted_177 = ["onUpdate:modelValue", "onChange"]
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "validateoption ml-2.5" }, "Only correct answer", -1))
const _hoisted_179 = { class: "buttonposition flex justify-center items-center my-1.5 mx-0" }
const _hoisted_180 = ["onClick"]
const _hoisted_181 = { key: 3 }
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mt-2 block" }, "Enter the Data", -1))
const _hoisted_183 = [
  _hoisted_182
]
const _hoisted_184 = {
  key: 4,
  class: "card formgroup mt-2.5"
}
const _hoisted_185 = { class: "accordion-head optionscontainer border bg-white mt-2.5 p-1.5 text-black flex justify-between min-h-30" }
const _hoisted_186 = { class: "imgoptioncontainer flex" }
const _hoisted_187 = { class: "ml-2 text-xs" }
const _hoisted_188 = { class: "flex gap-3" }
const _hoisted_189 = ["onClick"]
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  class: "h-5 w-5"
}, null, -1))
const _hoisted_191 = [
  _hoisted_190
]
const _hoisted_192 = ["onClick"]
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "h-5 w-5"
}, null, -1))
const _hoisted_194 = [
  _hoisted_193
]
const _hoisted_195 = { class: "text-black no-underline mt-6 min-h-30" }
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel flex justify-between bg-white text-xs pl-2" }, "options to add", -1))
const _hoisted_197 = { class: "accordion-body p-6" }
const _hoisted_198 = { key: 0 }
const _hoisted_199 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_200 = { class: "buttonposition flex justify-center items-center my-1.5 mx-0" }
const _hoisted_201 = ["onClick"]
const _hoisted_202 = ["onClick"]
const _hoisted_203 = { key: 5 }
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mt-2 block" }, "Enter the Accordion", -1))
const _hoisted_205 = [
  _hoisted_204
]
const _hoisted_206 = {
  key: 6,
  class: "card optionsblock mt-6"
}
const _hoisted_207 = { class: "accordion-head optionscontainer border bg-white mt-2.5 p-1.5 text-black flex justify-between min-h-30" }
const _hoisted_208 = { class: "imgoptioncontainer flex" }
const _hoisted_209 = { class: "ml-2 text-xs" }
const _hoisted_210 = { class: "flex gap-3" }
const _hoisted_211 = ["onClick"]
const _hoisted_212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  class: "h-5 w-5"
}, null, -1))
const _hoisted_213 = [
  _hoisted_212
]
const _hoisted_214 = ["onClick"]
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "h-5 w-5"
}, null, -1))
const _hoisted_216 = [
  _hoisted_215
]
const _hoisted_217 = { class: "text-black no-underline mt-6 min-h-30" }
const _hoisted_218 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel flex justify-between bg-white py-2.5 px-2 text-xs" }, "options to add", -1))
const _hoisted_219 = { class: "accordion-body p-6" }
const _hoisted_220 = { key: 0 }
const _hoisted_221 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_222 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_223 = { key: 1 }
const _hoisted_224 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_225 = {
  key: 1,
  class: "text-red-500 text-xs"
}
const _hoisted_226 = { class: "buttonposition flex justify-center items-center my-1.5 mx-0" }
const _hoisted_227 = ["onClick"]
const _hoisted_228 = ["onClick"]
const _hoisted_229 = { key: 7 }
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mt-2 block" }, "Enter the Tabs Data", -1))
const _hoisted_231 = [
  _hoisted_230
]
const _hoisted_232 = {
  key: 8,
  class: "accordion optionsblock"
}
const _hoisted_233 = { class: "optionscontainer accordion-head border rounded border-grey mt-2.5 p-1.5 text-white flex justify-between bg-darkslategrey min-h-30" }
const _hoisted_234 = { class: "imgoptioncontainer flex" }
const _hoisted_235 = { class: "ml-2 text-black text-xs" }
const _hoisted_236 = { class: "flex gap-3" }
const _hoisted_237 = ["onClick"]
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  class: "h-5 w-5"
}, null, -1))
const _hoisted_239 = [
  _hoisted_238
]
const _hoisted_240 = ["onClick"]
const _hoisted_241 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "h-5 w-5"
}, null, -1))
const _hoisted_242 = [
  _hoisted_241
]
const _hoisted_243 = { class: "text-black no-underline mt-1 min-h-30" }
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex controllabel justify-between bg-white py-2.5 px-2 text-xs rounded" }, "options to add", -1))
const _hoisted_245 = { class: "p-6" }
const _hoisted_246 = { key: 0 }
const _hoisted_247 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_248 = { key: 1 }
const _hoisted_249 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_250 = {
  key: 1,
  class: "text-red-500 text-xs"
}
const _hoisted_251 = { class: "mt-2.5" }
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Image", -1))
const _hoisted_253 = ["htmlFor"]
const _hoisted_254 = ["id", "onChange"]
const _hoisted_255 = { class: "border inputboxstylingforAddImage rounded py-2 border-lightgrey" }
const _hoisted_256 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_257 = { class: "flex justify-center" }
const _hoisted_258 = ["htmlFor"]
const _hoisted_259 = { class: "flex justify-center items-center mt-2" }
const _hoisted_260 = { key: 0 }
const _hoisted_261 = { class: "text-sm font-bold" }
const _hoisted_262 = { key: 1 }
const _hoisted_263 = { class: "flex justify-center mt-px" }
const _hoisted_264 = ["htmlFor"]
const _hoisted_265 = ["src"]
const _hoisted_266 = ["htmlFor"]
const _hoisted_267 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "-mt-10 flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "borderstyle p-1 font-semibold text-xs cursor-pointer" }, "Edit Image")
], -1))
const _hoisted_268 = [
  _hoisted_267
]
const _hoisted_269 = { class: "flex justify-center items-center mt-2" }
const _hoisted_270 = { key: 0 }
const _hoisted_271 = { class: "text-sm font-bold" }
const _hoisted_272 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mt-2.5" }, "Audio", -1))
const _hoisted_273 = { class: "flex inputboxstylingforAddAudio justify-center items-center cursor-pointer border rounded py-2 border-lightgrey" }
const _hoisted_274 = { class: "formgroup" }
const _hoisted_275 = ["htmlFor"]
const _hoisted_276 = ["id", "onChange"]
const _hoisted_277 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_278 = ["htmlFor"]
const _hoisted_279 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  class: "w-52 h-32 cursor-pointer"
}, null, -1))
const _hoisted_280 = [
  _hoisted_279
]
const _hoisted_281 = { class: "flex justify-center items-center mt-2" }
const _hoisted_282 = { key: 0 }
const _hoisted_283 = { class: "text-sm font-bold" }
const _hoisted_284 = {
  key: 1,
  class: "mt-px"
}
const _hoisted_285 = { class: "flex justify-center border border-lightgrey rounded" }
const _hoisted_286 = ["htmlFor"]
const _hoisted_287 = ["htmlFor"]
const _hoisted_288 = ["src"]
const _hoisted_289 = { class: "-mt-14 flex justify-center" }
const _hoisted_290 = ["htmlFor"]
const _hoisted_291 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "borderstyle p-1" }, "Edit Audio", -1))
const _hoisted_292 = [
  _hoisted_291
]
const _hoisted_293 = { class: "flex justify-center items-center mt-6" }
const _hoisted_294 = { key: 0 }
const _hoisted_295 = { class: "text-sm font-bold" }
const _hoisted_296 = { class: "buttonposition flex justify-center items-center my-1.5 mx-0" }
const _hoisted_297 = ["onClick"]
const _hoisted_298 = ["onClick"]
const _hoisted_299 = { class: "p-4" }
const _hoisted_300 = ["id"]
const _hoisted_301 = {
  key: 0,
  class: "buttonposition flex justify-center items-center"
}
const _hoisted_302 = ["id", "onClick"]
const _hoisted_303 = {
  key: 1,
  class: "buttonposition flex justify-center items-center"
}
const _hoisted_304 = ["id", "onClick"]
const _hoisted_305 = {
  key: 2,
  class: "buttonposition flex justify-center items-center ml-6"
}
const _hoisted_306 = ["id", "onClick"]
const _hoisted_307 = {
  key: 3,
  class: "buttonposition flex justify-center items-center ml-6"
}
const _hoisted_308 = ["id", "onClick"]
const _hoisted_309 = {
  key: 4,
  class: "flex justify-center items-center ml-6"
}
const _hoisted_310 = ["id", "onClick"]
const _hoisted_311 = {
  key: 5,
  class: "flex justify-center items-center ml-6"
}
const _hoisted_312 = ["id", "onClick"]
const _hoisted_313 = {
  key: 1,
  class: "text-center flex justify-center items-center text-sm mt-8 text-black"
}
const _hoisted_314 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "No Screens. Please start adding by clicking on Add button on top.", -1))
const _hoisted_315 = [
  _hoisted_314
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_spinner = _resolveComponent("spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    (_ctx.course.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.moduleName[0].moduleName), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: "btnprimary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addScreen()))
                }, "Add Screen")
              ])
            ])
          ]),
          (_ctx.screens.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.screens, (singlescreen, moduleIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["text-black no-underline mt-3 min-h-30 cursor-pointer", { accordion: singlescreen.isActive }]),
                    key: singlescreen.id
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex justify-between bg-white py-2.5 px-2.5 text-sm rounded", { 'accordion-head': !singlescreen.isActive }]),
                      onClick: ($event: any) => (_ctx.screenSelect(singlescreen, moduleIndex,'titleBar'))
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          (!singlescreen.isActive)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                            : (_openBlock(), _createElementBlock("img", _hoisted_11))
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("h6", _hoisted_13, _toDisplayString(singlescreen.screenName), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        (_ctx.screens[moduleIndex].isScreenActive == true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                          : (_openBlock(), _createElementBlock("div", _hoisted_16))
                      ])
                    ], 10, _hoisted_7),
                    (singlescreen.isActive)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "accordion-body bg-white",
                          onClick: _withModifiers(($event: any) => (_ctx.updateIndex(moduleIndex,$event)), ["stop"])
                        }, [
                          _hoisted_18,
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                  _hoisted_22,
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(["inputboxstyling", {
												'error-border p-1': (singlescreen.validationScreenName && _ctx.validCode == singlescreen.screenName) || _ctx.v$.currentScreen.screenName.$error
											}]),
                                    placeholder: "Name of the heading",
                                    "onUpdate:modelValue": ($event: any) => ((singlescreen.screenName) = $event)
                                  }, null, 10, _hoisted_23), [
                                    [_vModelText, singlescreen.screenName]
                                  ]),
                                  (_ctx.v$.currentScreen.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                        (_ctx.v$.currentScreen.screenName.$error)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (singlescreen.validationScreenName && _ctx.validCode == singlescreen.screenName)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                        (singlescreen.validationScreenName && _ctx.validCode == singlescreen.screenName)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Screen Name Already Exist"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("label", _hoisted_29, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.screens[moduleIndex].isScreenActive) = $event)
                                    }, null, 8, _hoisted_30), [
                                      [_vModelCheckbox, _ctx.screens[moduleIndex].isScreenActive]
                                    ]),
                                    _hoisted_31
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                _hoisted_33,
                                _withDirectives(_createElementVNode("select", {
                                  class: _normalizeClass(["inputboxstyling", {
											'error-border': _ctx.v$.currentScreen.$error && _ctx.v$.currentScreen.screenType.$error
										}]),
                                  "onUpdate:modelValue": ($event: any) => ((singlescreen.screenType) = $event),
                                  disabled: singlescreen._id,
                                  onChange: _withModifiers(($event: any) => (_ctx.changedInputControlValue(singlescreen, moduleIndex)), ["stop"])
                                }, _hoisted_44, 42, _hoisted_34), [
                                  [_vModelSelect, singlescreen.screenType]
                                ]),
                                (_ctx.v$.currentScreen.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                      (_ctx.v$.currentScreen.screenType.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (singlescreen.screenType && singlescreen.screenType == 'VideoScreen')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, [
                                      _hoisted_49,
                                      _createElementVNode("div", null, [
                                        _createElementVNode("label", { htmlFor: moduleIndex }, [
                                          (_openBlock(), _createElementBlock("input", {
                                            type: "file",
                                            id: moduleIndex,
                                            style: {"display":"none"},
                                            ref_for: true,
                                            ref: 'element' + moduleIndex,
                                            onChange: _withModifiers(($event: any) => (_ctx.imageCheckFile(moduleIndex,'element')), ["stop"]),
                                            key: _ctx.fileInputKey
                                          }, null, 40, _hoisted_51))
                                        ], 8, _hoisted_50)
                                      ]),
                                      _createElementVNode("div", _hoisted_52, [
                                        (singlescreen.videoUrl == '' && _ctx.pagetype == 'edit')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                              _createElementVNode("div", _hoisted_54, [
                                                _createElementVNode("label", {
                                                  htmlFor: moduleIndex,
                                                  class: "mt-2"
                                                }, [
                                                  _createElementVNode("img", {
                                                    src: _imports_2,
                                                    alt: "",
                                                    class: "w-52 h-32 cursor-pointer",
                                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showImageBlock = !_ctx.showImageBlock))
                                                  })
                                                ], 8, _hoisted_55)
                                              ]),
                                              _createElementVNode("div", _hoisted_56, [
                                                (_ctx.fileName)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                                      _createTextVNode("Selected File : "),
                                                      _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.fileName), 1)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]))
                                          : (singlescreen.videoUrl == '' && _ctx.pagetype == 'update')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                                _createElementVNode("label", { htmlFor: moduleIndex }, [
                                                  _createElementVNode("img", {
                                                    src: _imports_3,
                                                    alt: "",
                                                    class: "w-52 h-32 cursor-pointer",
                                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showImageBlock = !_ctx.showImageBlock))
                                                  })
                                                ], 8, _hoisted_60),
                                                _createElementVNode("div", _hoisted_61, [
                                                  (_ctx.fileName)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                                        _createTextVNode("Selected File : "),
                                                        _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.fileName), 1)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                _createElementVNode("div", _hoisted_65, [
                                                  _createElementVNode("label", {
                                                    htmlFor: moduleIndex,
                                                    class: "mt-px"
                                                  }, [
                                                    _createElementVNode("video", {
                                                      ref_for: true,
                                                      ref: "player",
                                                      preload: "metadata",
                                                      class: "w-96 h-52"
                                                    }, [
                                                      _createElementVNode("source", {
                                                        type: "video/mp4",
                                                        src: singlescreen.videoUrl
                                                      }, null, 8, _hoisted_67),
                                                      _createTextVNode(" Your browser does not support the video tag. ")
                                                    ], 512)
                                                  ], 8, _hoisted_66)
                                                ]),
                                                _hoisted_68,
                                                _createElementVNode("div", _hoisted_69, [
                                                  (_ctx.fileName)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                                        _createTextVNode("Selected File: "),
                                                        _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.fileName), 1)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]))
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (singlescreen.screenType&&singlescreen.screenType !== 'VideoScreen')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                    _createElementVNode("div", _hoisted_73, [
                                      _hoisted_74,
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(["inputboxstyling", {
												'error-border': _ctx.v$.currentScreen.$error && _ctx.v$.currentScreen.headerLabel.$error
											}]),
                                        placeholder: "Name of the heading",
                                        "onUpdate:modelValue": ($event: any) => ((singlescreen.headerLabel) = $event)
                                      }, null, 10, _hoisted_75), [
                                        [_vModelText, singlescreen.headerLabel]
                                      ]),
                                      (_ctx.v$.currentScreen.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                            (_ctx.v$.currentScreen.headerLabel.$error)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_77, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_78, [
                                      _hoisted_79,
                                      _withDirectives(_createElementVNode("textarea", {
                                        placeholder: "Text",
                                        name: "",
                                        class: _normalizeClass(["inputboxstyling", {
    											'error-border': _ctx.v$.currentScreen.$error && _ctx.v$.currentScreen.headerData.$error
											}]),
                                        id: "",
                                        cols: "3",
                                        rows: "3",
                                        "onUpdate:modelValue": ($event: any) => ((singlescreen.headerData) = $event)
                                      }, "\n\t\t\t\t\t\t\t\t\t\t", 10, _hoisted_80), [
                                        [_vModelText, singlescreen.headerData]
                                      ]),
                                      (_ctx.v$.currentScreen.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                            (_ctx.v$.currentScreen.headerData.maxLengthValue.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_82, " Characters should not be more than 300 "))
                                              : (_ctx.v$.currentScreen.headerData.$error)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_83, "Required"))
                                                : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (singlescreen.screenType !== 'TabScreen' && singlescreen.screenType !== 'VerticallyAccordionScreen' && singlescreen.screenType !== 'HorizantallyAccordionScreen')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                          _hoisted_85,
                                          _createElementVNode("div", null, [
                                            _createElementVNode("label", { htmlFor: moduleIndex }, [
                                              _createElementVNode("input", {
                                                type: "file",
                                                id: moduleIndex,
                                                style: {"display":"none"},
                                                ref_for: true,
                                                ref: 'element' + moduleIndex,
                                                onChange: _withModifiers(($event: any) => (_ctx.imageCheckFile(moduleIndex,'element')), ["stop"])
                                              }, null, 40, _hoisted_87)
                                            ], 8, _hoisted_86)
                                          ]),
                                          _createElementVNode("div", _hoisted_88, [
                                            _createElementVNode("div", null, [
                                              (singlescreen.imageUrl == '' && _ctx.pagetype == 'edit')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                                    _createElementVNode("div", {
                                                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.isScreenselected && _ctx.isScreenselected(...args))),
                                                      class: "flex justify-center"
                                                    }, [
                                                      _createElementVNode("label", {
                                                        htmlFor: moduleIndex,
                                                        class: _normalizeClass([{'pointer-events-none':_ctx.enableUpload}, "mt-2"])
                                                      }, _hoisted_92, 10, _hoisted_90)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_93, [
                                                      (_ctx.fileName)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                                            _createTextVNode("Selected File : "),
                                                            _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.fileName), 1)
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ])
                                                  ]))
                                                : (singlescreen.imageUrl == '' && _ctx.pagetype == 'update')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                                      _createElementVNode("label", { htmlFor: moduleIndex }, _hoisted_99, 8, _hoisted_97),
                                                      _createElementVNode("div", _hoisted_100, [
                                                        (_ctx.fileName)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                                              _createTextVNode("Selected File: "),
                                                              _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.fileName), 1)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ])
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                                      _createElementVNode("div", _hoisted_104, [
                                                        _createElementVNode("label", { htmlFor: moduleIndex }, [
                                                          _createElementVNode("img", {
                                                            src: singlescreen.imageUrl,
                                                            alt: "",
                                                            class: "w-96 h-52 cursor-pointer"
                                                          }, null, 8, _hoisted_106)
                                                        ], 8, _hoisted_105)
                                                      ]),
                                                      _createElementVNode("label", { htmlFor: moduleIndex }, _hoisted_109, 8, _hoisted_107),
                                                      _createElementVNode("div", _hoisted_110, [
                                                        (_ctx.fileName)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                                              _createTextVNode("Selected File: "),
                                                              _createElementVNode("span", _hoisted_112, _toDisplayString(_ctx.fileName), 1)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ])
                                                    ]))
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (singlescreen.screenType !== 'TabScreen')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                          _createElementVNode("div", _hoisted_114, [
                                            _hoisted_115,
                                            _createElementVNode("div", null, [
                                              _createElementVNode("label", {
                                                htmlFor: moduleIndex+'audio'
                                              }, [
                                                (_openBlock(), _createElementBlock("input", {
                                                  type: "file",
                                                  id: moduleIndex+'audio',
                                                  style: {"display":"none"},
                                                  ref_for: true,
                                                  ref: 'elementAudio' + moduleIndex,
                                                  onChange: _withModifiers(($event: any) => (_ctx.audioCheckFile(moduleIndex)), ["stop"]),
                                                  key: _ctx.fileInputKey
                                                }, null, 40, _hoisted_117))
                                              ], 8, _hoisted_116)
                                            ]),
                                            _createElementVNode("div", _hoisted_118, [
                                              _createElementVNode("div", null, [
                                                (singlescreen.audioUrl == '' && _ctx.pagetype == 'edit')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                                      _createElementVNode("div", {
                                                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.isScreenselected && _ctx.isScreenselected(...args))),
                                                        class: "flex justify-center"
                                                      }, [
                                                        _createElementVNode("label", {
                                                          htmlFor: moduleIndex+'audio',
                                                          class: _normalizeClass([{'pointer-events-none':_ctx.enableUpload}, "mt-2"])
                                                        }, _hoisted_122, 10, _hoisted_120)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_123, [
                                                        (_ctx.fileNameAudio)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                                              _createTextVNode("Selected File : "),
                                                              _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.fileNameAudio), 1)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ])
                                                    ]))
                                                  : (singlescreen.audioUrl == '' && _ctx.pagetype == 'update')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                                        _createElementVNode("label", {
                                                          htmlFor: moduleIndex+'audio'
                                                        }, _hoisted_129, 8, _hoisted_127),
                                                        _createElementVNode("div", _hoisted_130, [
                                                          (_ctx.fileNameAudio)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                                                                _createTextVNode("Selected File: "),
                                                                _createElementVNode("span", _hoisted_132, _toDisplayString(_ctx.fileNameAudio), 1)
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ])
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                                        _createElementVNode("div", _hoisted_134, [
                                                          _createElementVNode("label", {
                                                            htmlFor: moduleIndex+'audio',
                                                            class: "w-96 h-52 cursor-pointer flex justify-center border border-lightgrey rounded"
                                                          }, [
                                                            _createElementVNode("audio", {
                                                              preload: "metadata",
                                                              controls: "",
                                                              controlsList: "nodownload noplaybackrate",
                                                              htmlFor: moduleIndex+'audio',
                                                              class: "mt-6"
                                                            }, [
                                                              _createElementVNode("source", {
                                                                src: singlescreen.audioUrl,
                                                                type: "audio/mp3"
                                                              }, null, 8, _hoisted_137)
                                                            ], 8, _hoisted_136)
                                                          ], 8, _hoisted_135)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_138, [
                                                          _createElementVNode("label", {
                                                            htmlFor: moduleIndex+'audio'
                                                          }, _hoisted_141, 8, _hoisted_139)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_142, [
                                                          (_ctx.fileNameAudio)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                                                                _createTextVNode("Selected File: "),
                                                                _createElementVNode("span", _hoisted_144, _toDisplayString(_ctx.fileNameAudio), 1)
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ])
                                                      ]))
                                              ])
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (singlescreen.screenType == 'RadioScreen' || singlescreen.screenType == 'CheckBoxScreen')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                                          _hoisted_146,
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "inputboxstyling mb-3",
                                            placeholder: "Name of the options header",
                                            "onUpdate:modelValue": ($event: any) => ((singlescreen.optionsLabel) = $event)
                                          }, null, 8, _hoisted_147), [
                                            [_vModelText, singlescreen.optionsLabel]
                                          ]),
                                          _createElementVNode("div", _hoisted_148, [
                                            _hoisted_149,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singlescreen.options, (singleoption, optionIndex) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: singleoption.id
                                              }, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["accordion-head optionscontainer border bg-white mt-2.5 p-1.5 text-black flex justify-between min-h-30", {
													'error-border p-1': singlescreen.options.length < 2
												}])
                                                }, [
                                                  _createElementVNode("div", _hoisted_150, [
                                                    (singleoption.isCorrect)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_151, _hoisted_153))
                                                      : (_openBlock(), _createElementBlock("div", _hoisted_154, _hoisted_156)),
                                                    _createElementVNode("div", _hoisted_157, _toDisplayString(singleoption.label), 1)
                                                  ]),
                                                  _createElementVNode("div", {
                                                    onClick: ($event: any) => (_ctx.onDelete(optionIndex, moduleIndex))
                                                  }, _hoisted_160, 8, _hoisted_158)
                                                ], 2),
                                                (singlescreen.options.length < 2)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_161, _hoisted_163))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128)),
                                            _createElementVNode("div", _hoisted_164, [
                                              _hoisted_165,
                                              _createElementVNode("div", _hoisted_166, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "text",
                                                  class: _normalizeClass(["inputboxstyling", {
															'error-border': _ctx.v$.radioScreenObject.$error && _ctx.v$.radioScreenObject.optionsData.$error && singlescreen.options.length < 2
														}]),
                                                  placeholder: "Options",
                                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.radioScreenObject.optionsData) = $event))
                                                }, null, 2), [
                                                  [_vModelText, _ctx.radioScreenObject.optionsData]
                                                ]),
                                                (_ctx.v$.radioScreenObject.$error)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                                      (_ctx.v$.radioScreenObject.optionsData &&  singlescreen.options.length<2)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_168, "Required"))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                ((singlescreen.answerVisibility || _ctx.optionsCount == 0) && singlescreen.screenType == 'RadioScreen')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                                                      _createElementVNode("div", _hoisted_170, [
                                                        _createElementVNode("label", _hoisted_171, [
                                                          _withDirectives(_createElementVNode("input", {
                                                            type: "checkbox",
                                                            id: "check",
                                                            class: "pt-px",
                                                            "onUpdate:modelValue": ($event: any) => ((singlescreen.correctAnswer) = $event),
                                                            onChange: ($event: any) => (_ctx.selectedQuestionChange(singlescreen.correctAnswer))
                                                          }, null, 40, _hoisted_172), [
                                                            [_vModelCheckbox, singlescreen.correctAnswer]
                                                          ]),
                                                          _hoisted_173
                                                        ])
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (singlescreen.screenType == 'CheckBoxScreen')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                                                      _createElementVNode("div", _hoisted_175, [
                                                        _createElementVNode("label", _hoisted_176, [
                                                          _withDirectives(_createElementVNode("input", {
                                                            type: "checkbox",
                                                            id: "check",
                                                            class: "pt-px",
                                                            "onUpdate:modelValue": ($event: any) => ((singlescreen.correctAnswer) = $event),
                                                            onChange: ($event: any) => (_ctx.selectedQuestionChange(singlescreen.correctAnswer))
                                                          }, null, 40, _hoisted_177), [
                                                            [_vModelCheckbox, singlescreen.correctAnswer]
                                                          ]),
                                                          _hoisted_178
                                                        ])
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("div", _hoisted_179, [
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: _normalizeClass(["m-2.5", singlescreen.options.length<3?'btnprimary':'poniter-events-none btndisabled']),
                                                  onClick: ($event: any) => (_ctx.addOptions(moduleIndex, _ctx.radioScreenObject.optionsData))
                                                }, "Add", 10, _hoisted_180)
                                              ])
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (singlescreen.screenType == 'TextWithBulletPointsScreen')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_181, _hoisted_183))
                                      : _createCommentVNode("", true),
                                    (singlescreen.screenType == 'TextWithBulletPointsScreen')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singlescreen.textbullets, (singletext, optionIndex) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: singletext.id,
                                              class: "px-2"
                                            }, [
                                              _createElementVNode("div", _hoisted_185, [
                                                _createElementVNode("div", _hoisted_186, [
                                                  _createElementVNode("div", _hoisted_187, _toDisplayString(singletext.text), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_188, [
                                                  _createElementVNode("div", {
                                                    onClick: ($event: any) => (_ctx.ontextbulletEdit(optionIndex, moduleIndex))
                                                  }, _hoisted_191, 8, _hoisted_189),
                                                  _createElementVNode("div", {
                                                    onClick: ($event: any) => (_ctx.ontextbulletDelete(optionIndex, moduleIndex))
                                                  }, _hoisted_194, 8, _hoisted_192)
                                                ])
                                              ])
                                            ]))
                                          }), 128)),
                                          _createElementVNode("div", _hoisted_195, [
                                            _hoisted_196,
                                            _createElementVNode("div", _hoisted_197, [
                                              _withDirectives(_createElementVNode("textarea", {
                                                name: "",
                                                class: _normalizeClass(["inputboxstyling mt-4", {'error-border':_ctx.v$.presentbulletPoint.$error && _ctx.v$.presentbulletPoint.text.$error && singlescreen.textbullets.length<3}]),
                                                id: "",
                                                cols: "3",
                                                rows: "3",
                                                placeholder: "Accordion Data",
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.presentbulletPoint.text) = $event))
                                              }, null, 2), [
                                                [_vModelText, _ctx.presentbulletPoint.text]
                                              ]),
                                              (_ctx.v$.presentbulletPoint.$error && singlescreen.textbullets.length<3)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                                                    (_ctx.v$.presentbulletPoint.text.$error)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_199, "Required"))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_200, [
                                              (!_ctx.updateButton)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    class: _normalizeClass((_ctx.presentbulletPoint.label==''|| _ctx.presentbulletPoint.label==undefined)&& (_ctx.presentbulletPoint.text==''||_ctx.presentbulletPoint.text==undefined) ?'btndisabled pointer-events-none':'btnprimary'),
                                                    onClick: ($event: any) => (_ctx.savetextbulletData(moduleIndex))
                                                  }, "Add", 10, _hoisted_201))
                                                : _createCommentVNode("", true),
                                              (_ctx.updateButton)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 1,
                                                    type: "button",
                                                    class: _normalizeClass(JSON.stringify(_ctx.presentbulletPoint)!=JSON.stringify(_ctx.dummybulletPoint) ? 'btnprimary' : 'btndisabled pointer-events-none '),
                                                    onClick: ($event: any) => (_ctx.updatetextbulletData(moduleIndex))
                                                  }, "Update", 10, _hoisted_202))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (singlescreen.screenType == 'HorizantallyAccordionScreen' || singlescreen.screenType == 'VerticallyAccordionScreen')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_203, _hoisted_205))
                                      : _createCommentVNode("", true),
                                    (singlescreen.screenType == 'HorizantallyAccordionScreen' || singlescreen.screenType == 'VerticallyAccordionScreen')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_206, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singlescreen.accordions, (singleoption, optionIndex) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: singleoption.id,
                                              class: "px-2"
                                            }, [
                                              _createElementVNode("div", _hoisted_207, [
                                                _createElementVNode("div", _hoisted_208, [
                                                  _createElementVNode("div", _hoisted_209, _toDisplayString(singleoption.label), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_210, [
                                                  _createElementVNode("div", {
                                                    onClick: ($event: any) => (_ctx.onVerticallyChildAccordionEdit(optionIndex, moduleIndex))
                                                  }, _hoisted_213, 8, _hoisted_211),
                                                  _createElementVNode("div", {
                                                    onClick: ($event: any) => (_ctx.onVerticallyChildAccordionDelete(optionIndex, moduleIndex))
                                                  }, _hoisted_216, 8, _hoisted_214)
                                                ])
                                              ])
                                            ]))
                                          }), 128)),
                                          _createElementVNode("div", _hoisted_217, [
                                            _hoisted_218,
                                            _createElementVNode("div", _hoisted_219, [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: _normalizeClass(["inputboxstyling", {'error-border':_ctx.v$.accordionOriginalObject.label.$error && singlescreen.accordions.length<4
												  }]),
                                                placeholder: "Name of the Accordion",
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.accordionOriginalObject.label) = $event))
                                              }, null, 2), [
                                                [_vModelText, _ctx.accordionOriginalObject.label]
                                              ]),
                                              (_ctx.v$.accordionOriginalObject.label.$error)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_220, [
                                                    (_ctx.v$.accordionOriginalObject.label.$error && singlescreen.accordions.length<4)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_221, "Required"))
                                                      : _createCommentVNode("", true),
                                                    (singlescreen.accordions.length > 4)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_222, " should not be greater than 4"))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _withDirectives(_createElementVNode("textarea", {
                                                name: "",
                                                class: _normalizeClass(["inputboxstyling mt-3", {'error-border':_ctx.v$.accordionOriginalObject.text.$error && singlescreen.accordions.length<4}]),
                                                id: "",
                                                cols: "3",
                                                rows: "3",
                                                placeholder: "Accordion Data",
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.accordionOriginalObject.text) = $event))
                                              }, null, 2), [
                                                [_vModelText, _ctx.accordionOriginalObject.text]
                                              ]),
                                              (_ctx.v$.accordionOriginalObject.$error)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_223, [
                                                    (_ctx.v$.accordionOriginalObject.text.maxLengthValue.$invalid)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_224, "Characters should not be more than 400 "))
                                                      : (_ctx.v$.accordionOriginalObject.text.$error && singlescreen.accordions.length<4)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_225, "Required"))
                                                        : _createCommentVNode("", true)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_226, [
                                              (!_ctx.updateButton)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    class: _normalizeClass((_ctx.accordionOriginalObject.label==''|| _ctx.accordionOriginalObject.label==undefined)&& (_ctx.accordionOriginalObject.text==''||_ctx.accordionOriginalObject.text==undefined) ?'btndisabled pointer-events-none':'btnprimary'),
                                                    onClick: ($event: any) => (_ctx.saveVerticallyChildAccordionData(moduleIndex))
                                                  }, "Add", 10, _hoisted_227))
                                                : _createCommentVNode("", true),
                                              (_ctx.updateButton)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 1,
                                                    type: "button",
                                                    class: _normalizeClass(JSON.stringify(_ctx.accordionOriginalObject)!=JSON.stringify(_ctx.dummyAccordionObj) ?'btnprimary':'btndisabled pointer-events-none'),
                                                    onClick: ($event: any) => (_ctx.updateVerticallyChildAccordionData(moduleIndex))
                                                  }, "Update", 10, _hoisted_228))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (singlescreen.screenType == 'TabScreen')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_229, _hoisted_231))
                                      : _createCommentVNode("", true),
                                    (singlescreen.screenType == 'TabScreen')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_232, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singlescreen.tabs, (singleoption, optionIndex) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: singleoption.id,
                                              class: "px-2"
                                            }, [
                                              _createElementVNode("div", _hoisted_233, [
                                                _createElementVNode("div", _hoisted_234, [
                                                  _createElementVNode("div", _hoisted_235, _toDisplayString(singleoption.label), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_236, [
                                                  _createElementVNode("div", {
                                                    onClick: ($event: any) => (_ctx.onTabEdit(optionIndex, moduleIndex))
                                                  }, _hoisted_239, 8, _hoisted_237),
                                                  _createElementVNode("div", {
                                                    onClick: ($event: any) => (_ctx.onTabDelete(optionIndex, moduleIndex))
                                                  }, _hoisted_242, 8, _hoisted_240)
                                                ])
                                              ])
                                            ]))
                                          }), 128)),
                                          _createElementVNode("div", _hoisted_243, [
                                            _hoisted_244,
                                            _createElementVNode("div", _hoisted_245, [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: _normalizeClass(["inputboxstyling", {'error-border':_ctx.v$.tabScreenObject.label.$error && singlescreen.tabs.length<2}]),
                                                placeholder: "Name of the Tab",
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tabScreenObject.label) = $event))
                                              }, null, 2), [
                                                [_vModelText, _ctx.tabScreenObject.label]
                                              ]),
                                              (_ctx.v$.tabScreenObject.$error)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_246, [
                                                    (_ctx.v$.tabScreenObject.label.$error  && singlescreen.tabs.length<2)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_247, "Required"))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _withDirectives(_createElementVNode("textarea", {
                                                name: "",
                                                class: _normalizeClass(["inputboxstyling mt-4", {'error-border':_ctx.v$.tabScreenObject.$error && _ctx.v$.tabScreenObject.text.$error && singlescreen.tabs.length<2}]),
                                                id: "",
                                                cols: "3",
                                                rows: "3",
                                                placeholder: "Accordion Data",
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.tabScreenObject.text) = $event))
                                              }, null, 2), [
                                                [_vModelText, _ctx.tabScreenObject.text]
                                              ]),
                                              (_ctx.v$.tabScreenObject.$error)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_248, [
                                                    (_ctx.v$.tabScreenObject.text.maxLengthValue.$invalid)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_249, "Characters should not be more than 1000 "))
                                                      : (_ctx.v$.tabScreenObject.text.$error  && singlescreen.tabs.length<2)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_250, "Required"))
                                                        : _createCommentVNode("", true)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("div", _hoisted_251, [
                                                _hoisted_252,
                                                _createElementVNode("label", {
                                                  htmlFor: singlescreen.tabs.length
                                                }, [
                                                  (_openBlock(), _createElementBlock("input", {
                                                    type: "file",
                                                    id: singlescreen.tabs.length,
                                                    style: {"display":"none"},
                                                    ref_for: true,
                                                    ref: "fileInput",
                                                    onChange: _withModifiers(($event: any) => (_ctx.imageCheckFile(moduleIndex,'fileInput')), ["stop"]),
                                                    key: _ctx.fileInputKey
                                                  }, null, 40, _hoisted_254))
                                                ], 8, _hoisted_253)
                                              ]),
                                              _createElementVNode("div", _hoisted_255, [
                                                (_ctx.tabScreenObject.imageUrl==undefined ||_ctx.tabScreenObject.imageUrl=='')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_256, [
                                                      _createElementVNode("div", null, [
                                                        _createElementVNode("div", _hoisted_257, [
                                                          _createElementVNode("label", {
                                                            htmlFor: singlescreen.tabs.length,
                                                            class: "mt-2"
                                                          }, [
                                                            _createElementVNode("img", {
                                                              src: _imports_4,
                                                              alt: "",
                                                              class: "w-52 h-32 cursor-pointer",
                                                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showImageBlock = !_ctx.showImageBlock))
                                                            })
                                                          ], 8, _hoisted_258)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_259, [
                                                          (_ctx.fileName)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_260, [
                                                                _createTextVNode("Selected File : "),
                                                                _createElementVNode("span", _hoisted_261, _toDisplayString(_ctx.fileName), 1)
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ])
                                                      ])
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_262, [
                                                      _createElementVNode("div", _hoisted_263, [
                                                        _createElementVNode("label", {
                                                          htmlFor: singlescreen.tabs.length
                                                        }, [
                                                          _createElementVNode("img", {
                                                            alt: "",
                                                            src: _ctx.tabScreenObject.imageUrl,
                                                            class: "w-96 h-52 cursor-pointer"
                                                          }, null, 8, _hoisted_265)
                                                        ], 8, _hoisted_264)
                                                      ]),
                                                      _createElementVNode("label", {
                                                        htmlFor: singlescreen.tabs.length
                                                      }, _hoisted_268, 8, _hoisted_266),
                                                      _createElementVNode("div", _hoisted_269, [
                                                        (_ctx.fileName)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_270, [
                                                              _createTextVNode("Selected File : "),
                                                              _createElementVNode("span", _hoisted_271, _toDisplayString(_ctx.fileName), 1)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ])
                                                    ]))
                                              ]),
                                              _hoisted_272,
                                              _createElementVNode("div", _hoisted_273, [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("div", _hoisted_274, [
                                                    _createElementVNode("div", null, [
                                                      _createElementVNode("label", {
                                                        htmlFor: singlescreen.tabs.length+'audio'
                                                      }, [
                                                        _createElementVNode("input", {
                                                          type: "file",
                                                          id: singlescreen.tabs.length+'audio',
                                                          style: {"display":"none"},
                                                          ref_for: true,
                                                          ref: "fileInputAudio",
                                                          onChange: _withModifiers(($event: any) => (_ctx.audioCheckFile(moduleIndex)), ["stop"])
                                                        }, null, 40, _hoisted_276)
                                                      ], 8, _hoisted_275)
                                                    ])
                                                  ]),
                                                  (_ctx.tabScreenObject.audioUrl==undefined ||_ctx.tabScreenObject.audioUrl=='')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_277, [
                                                        _createElementVNode("div", {
                                                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.isScreenselected && _ctx.isScreenselected(...args))),
                                                          class: "flex justify-center"
                                                        }, [
                                                          _createElementVNode("label", {
                                                            htmlFor: singlescreen.tabs.length+'audio',
                                                            class: _normalizeClass({'pointer-events-none':_ctx.enableUpload})
                                                          }, _hoisted_280, 10, _hoisted_278)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_281, [
                                                          (_ctx.fileNameAudio)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_282, [
                                                                _createTextVNode("Selected File : "),
                                                                _createElementVNode("span", _hoisted_283, _toDisplayString(_ctx.fileNameAudio), 1)
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ])
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_284, [
                                                        _createElementVNode("div", _hoisted_285, [
                                                          _createElementVNode("label", {
                                                            htmlFor: singlescreen.tabs.length+'audio',
                                                            class: "w-96 h-52 cursor-pointer flex justify-center"
                                                          }, [
                                                            _createElementVNode("audio", {
                                                              preload: "metadata",
                                                              controls: "",
                                                              controlsList: "nodownload noplaybackrate",
                                                              htmlFor: singlescreen.tabs.length+'audio',
                                                              class: "mt-6"
                                                            }, [
                                                              _createElementVNode("source", {
                                                                src: _ctx.tabScreenObject.audioUrl,
                                                                type: "audio/mp3"
                                                              }, null, 8, _hoisted_288)
                                                            ], 8, _hoisted_287)
                                                          ], 8, _hoisted_286)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_289, [
                                                          _createElementVNode("label", {
                                                            htmlFor: singlescreen.tabs.length+'audio'
                                                          }, _hoisted_292, 8, _hoisted_290)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_293, [
                                                          (_ctx.fileNameAudio)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_294, [
                                                                _createTextVNode("Selected File: "),
                                                                _createElementVNode("span", _hoisted_295, _toDisplayString(_ctx.fileNameAudio), 1)
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ])
                                                      ]))
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_296, [
                                            (!_ctx.updateButton && singlescreen.tabs.length <= 4)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  type: "button",
                                                  class: _normalizeClass((_ctx.tabScreenObject.label==''|| _ctx.tabScreenObject.label==undefined)&& (_ctx.tabScreenObject.text==''||_ctx.tabScreenObject.text==undefined) ?'btndisabled pointer-events-none':'btnprimary'),
                                                  onClick: ($event: any) => (_ctx.saveTabData(moduleIndex))
                                                }, "Add", 10, _hoisted_297))
                                              : _createCommentVNode("", true),
                                            (_ctx.updateButton)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 1,
                                                  type: "button",
                                                  class: _normalizeClass(JSON.stringify(_ctx.tabScreenObject)!=JSON.stringify(_ctx.dummyTabObj) || !_ctx.fileStatusName || _ctx.fileNameAudio ? 'btnprimary' : 'btndisabled pointer-events-none '),
                                                  onClick: ($event: any) => (_ctx.updateTabData(moduleIndex))
                                                }, "Update", 10, _hoisted_298))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_299, [
                              _createElementVNode("div", {
                                class: "flex justify-center",
                                id: moduleIndex+singlescreen.screenName
                              }, [
                                (moduleIndex+singlescreen.screenType=='TabScreen')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_301, [
                                      _createElementVNode("input", {
                                        type: "button",
                                        id: moduleIndex+'Reset',
                                        class: _normalizeClass( (JSON.stringify(_ctx.originalObject) != JSON.stringify(singlescreen)) || !_ctx.fileNameAudio ? 'btnprimary' : 'btndisabled pointer-events-none'),
                                        onClick: ($event: any) => (_ctx.resetData(singlescreen,moduleIndex)),
                                        value: "Reset"
                                      }, null, 10, _hoisted_302)
                                    ]))
                                  : _createCommentVNode("", true),
                                (moduleIndex+singlescreen.screenType!=='TabScreen')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_303, [
                                      _createElementVNode("input", {
                                        type: "button",
                                        id: moduleIndex+'Reset',
                                        class: _normalizeClass( (JSON.stringify(_ctx.originalObject) !== JSON.stringify(singlescreen)) || !_ctx.fileStatusName  || _ctx.fileNameAudio || _ctx.fileName!=''? 'btnprimary' : 'btndisabled pointer-events-none'),
                                        onClick: ($event: any) => (_ctx.resetData(singlescreen,moduleIndex)),
                                        value: "Reset"
                                      }, null, 10, _hoisted_304)
                                    ]))
                                  : _createCommentVNode("", true),
                                (singlescreen._id && moduleIndex+singlescreen.screenType=='TabScreen')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_305, [
                                      _createElementVNode("input", {
                                        type: "button",
                                        id: moduleIndex+'Update',
                                        class: _normalizeClass((JSON.stringify(_ctx.originalObject) != JSON.stringify(singlescreen))? 'btnprimary' : 'btndisabled pointer-events-none'),
                                        onClick: ($event: any) => (_ctx.createPayload(moduleIndex)),
                                        value: "Update"
                                      }, null, 10, _hoisted_306)
                                    ]))
                                  : _createCommentVNode("", true),
                                (singlescreen._id && moduleIndex+singlescreen.screenType!=='TabScreen')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_307, [
                                      _createElementVNode("input", {
                                        type: "button",
                                        id: moduleIndex+'Update',
                                        class: _normalizeClass((JSON.stringify(_ctx.originalObject) != JSON.stringify(singlescreen) || !_ctx.fileStatusName || _ctx.fileNameAudio || _ctx.fileName!='')? 'btnprimary' : 'btndisabled pointer-events-none'),
                                        onClick: ($event: any) => (_ctx.createPayload(moduleIndex)),
                                        value: "Update"
                                      }, null, 10, _hoisted_308)
                                    ]))
                                  : _createCommentVNode("", true),
                                (singlescreen._id)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_309, [
                                      _createElementVNode("input", {
                                        type: "button",
                                        id: moduleIndex+'Preview',
                                        class: _normalizeClass(singlescreen._id ? 'btnprimary' : 'btndisabled pointer-events-none'),
                                        onClick: ($event: any) => (_ctx.preview(singlescreen.screenType, singlescreen._id)),
                                        value: "Preview"
                                      }, null, 10, _hoisted_310)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_311, [
                                      _createElementVNode("input", {
                                        type: "button",
                                        id: moduleIndex+'Save',
                                        class: _normalizeClass((!singlescreen._id && !_ctx.fileStatusName) || (JSON.stringify(_ctx.originalObject) != JSON.stringify(singlescreen)  )? 'btnprimary' : 'btndisabled pointer-events-none'),
                                        onClick: ($event: any) => (_ctx.createPayload(moduleIndex)),
                                        value: "Save"
                                      }, null, 10, _hoisted_312)
                                    ]))
                              ], 8, _hoisted_300)
                            ])
                          ])
                        ], 8, _hoisted_17))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_313, _hoisted_315)),
          (_ctx.spinnerLoading)
            ? (_openBlock(), _createBlock(_component_spinner, { key: 2 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}